export enum Infills {
  horizontal = 'horizontal',
  stairs = 'stairs',
  stairsLanding = 'stairs-landing',
  tires = 'tires'
}


// WEBPACK FOOTER //
// ./src/app/services/railing/infills/model/infills.ts